export class Setting {

  constructor() {
    this.id = '';
    this.type = '';
    this.sequence = 0;
    this.name = '';
    this.description = '';
  }

  id: string;
  type: string;
  sequence: number;
  name: string;
  description: string;

}



// WEBPACK FOOTER //
// ./src/app/models/settings.ts